<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 13.63 13.63"
  >
    <path
      id="Icon_awesome-plus"
      data-name="Icon awesome-plus"
      d="M12.656,7.6H8.275V3.224A.974.974,0,0,0,7.3,2.25H6.328a.974.974,0,0,0-.974.974V7.6H.974A.974.974,0,0,0,0,8.578v.974a.974.974,0,0,0,.974.974H5.355v4.381a.974.974,0,0,0,.974.974H7.3a.974.974,0,0,0,.974-.974V10.525h4.381a.974.974,0,0,0,.974-.974V8.578A.974.974,0,0,0,12.656,7.6Z"
      transform="translate(0 -2.25)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-3'
    },
    height: {
      type: String,
      default: 'h-3'
    }
  }
}
</script>
